import { ConfirmationOptions } from "primevue/confirmationoptions";
import { PrimeVueConfirmSymbol } from "primevue/useconfirm";
import ConfirmationEventBus from "primevue/confirmationeventbus";

export const ConfirmationService = {
    install(app) {
        const ConfirmationService = {
            require: function require(options: ConfirmationOptions) {
                // Only do so when 'group' is not explicitly specified, so
                // users of this service can override the default behavior.
                if (!("group" in options)) {
                    // When 'target' is in options, we instruct the 'popup'
                    // component to respond to the confirmation request, otherwise
                    // we'll use the bigger 'dialog' component.
                    if ("target" in options) {
                        options["group"] = "popup";
                    } else {
                        options["group"] = "dialog";
                    }
                }
                ConfirmationEventBus.emit("confirm", options);
            },
            close: function close() {
                ConfirmationEventBus.emit("close");
            },
        };
        app.config.globalProperties.$confirm = ConfirmationService;
        app.provide(PrimeVueConfirmSymbol, ConfirmationService);
    },
};
